import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import { newApi } from 'base/redux/ctx';
import { getToken } from '../../admincore'

const { REACT_APP_BASE_URL: BASE_URL } = process.env

export const app_api = createApi({
  reducerPath: 'api_app',
  tagTypes: ['Login', 'VerifyToken'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api/v1`,
    prepareHeaders: headers => {
      if (!headers.has('authorization')) {
        headers.set('Authorization', `Bearer ${getToken()}`)
      }
    },
  }),
  endpoints: builder => ({
    verifyToken: builder.query({
      query: () => '/my-profile',
    }),
  }),
})

export const { useVerifyTokenQuery } = app_api
